import { render, staticRenderFns } from "./AutoReviewModal.vue?vue&type=template&id=96c8c35c&scoped=true"
import script from "./AutoReviewModal.vue?vue&type=script&lang=js"
export * from "./AutoReviewModal.vue?vue&type=script&lang=js"
import style0 from "./AutoReviewModal.vue?vue&type=style&index=0&id=96c8c35c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c8c35c",
  null
  
)

export default component.exports